import React from 'react';
import { Link } from 'gatsby';
import styles from '../styles/components/activity-tags.module.scss';
import Icon from './ActivityIcons';


const Tags = ({ tags, tagSlugs }) => (
  <div className={styles.tags}>
    <ul>
      {tagSlugs && tagSlugs.map((slug, i) => (
        <li key={tags[i]}>
          <Link to={slug}>
            <Icon name={tags[i]} />
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default Tags;